/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {UsersModule} from "@modules/UsersModule";
import {cc_logo_header} from "@res/icons";
import {LogoutButton} from "./LogoutButton";
import {COLORS} from "@res/colors";
import {FONTS} from "@res/fonts";
import {margin_r_lg, Spacing} from "@styles/styles";
import {PatientSearchBar} from "./PatientSearchBar";
import {EnvironmentModule} from "@modules/EnvironmentModule";
import {HGap} from "../widget/HGap";
import {UserGuideButton} from "./UserGuideButton";

export const RenderEnv = () => {
    if (EnvironmentModule.isProd())
        return null;

    return <>
        <div
            style={{
                fontSize: 30,
                color: COLORS.info_dark_orange,
                fontWeight: 900
            }}
        >
            {EnvironmentModule.getEnvName()}
        </div>
        <HGap h={Spacing.s}/>
    </>
};


export const AppHeader = ({disableSearch, style}: { disableSearch?: boolean, style?: React.CSSProperties }) => {
    const userNameWithTitle = UsersModule.getCurrentUser();

    return <div className={"ll_h_c match_width"} style={{height: 60, justifyContent: "space-between", ...style}}>
        <div className={`ll_v_c match_height ${margin_r_lg}`} style={{width: 106}}>
            <img alt="cc_logo" src={cc_logo_header} height={"100%"}/>
        </div>
        <div className={"ll_h_c fill"}>
            {userNameWithTitle && FONTS.reg_18(userNameWithTitle)}
            {!disableSearch && (
                <>
                    <div style={{height: 25, width: 1, margin: "0 16px", backgroundColor: COLORS.neutral_gray_1}}/>
                    <PatientSearchBar/>
                </>
            )}
        </div>
        <div className={"ll_h_c match_height"} style={{paddingRight: 30, gap: 22}}>
            <RenderEnv/>
            <UserGuideButton/>
            <LogoutButton/>
            {/* <HGap h={30}/> */}
            {/* <NotificationsButton/> */}
        </div>
    </div>
};